export function convertTime(time: any) {
  const [hour, minute] = time.split(":").map(Number);

  const period = hour >= 12 ? "PM" : "AM";
  let formattedMinute: any = minute === 0 ? "00" : minute;
  const formattedHour = hour % 12 || 12;

  const formattedTime = `${formattedHour}:${formattedMinute} ${period}`;

  return formattedTime;
}

export const getCurrentTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours() % 12 || 12).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  const ampm = now.getHours() >= 12 ? "PM" : "AM";
  const datetime = `${year}-${month}-${day}/${hour}:${minute} ${ampm}`;
  return datetime;
};

export const convertToUTC = (dateTimeString: any) => {
  const timeZoneMap = {
    UTC: 0,
    "Asia/Kolkata": 5.5 * 60 * 60 * 1000,
    "America/New_York": -5 * 60 * 60 * 1000,
  };

  const [dateString, timeString, ampm] = dateTimeString.split(" ");
  const [year, month, day] = dateString.split("-");

  const [hours, minutes] = timeString.split(":");
  let hours24 = parseInt(hours);
  if (ampm.toLowerCase() === "pm" && hours24 < 12) {
    hours24 += 12;
  } else if (ampm.toLowerCase() === "am" && hours24 === 12) {
    hours24 = 0;
  }
  const localDate = new Date(Date.UTC(year, month - 1, day, hours24, minutes));
  const localOffset = timeZoneMap["Asia/Kolkata"];
  const utcDate = new Date(localDate.getTime() - localOffset);

  const year2 = utcDate.getUTCFullYear();
  const month2 = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
  const day2 = String(utcDate.getUTCDate()).padStart(2, "0");
  const hours2 = String(utcDate.getUTCHours()).padStart(2, "0");
  const minutes2 = String(utcDate.getUTCMinutes()).padStart(2, "0");
  const seconds2 = String(utcDate.getUTCSeconds()).padStart(2, "0");
  const utcTimestamp1 = `${year2}${month2}${day2}T${hours2}${minutes2}${seconds2}Z`;

  const localDate1 = new Date(localDate.getTime() + 30 * 60 * 1000);
  const utcDate1 = new Date(localDate1.getTime() - localOffset);

  const year3 = utcDate1.getUTCFullYear();
  const month3 = String(utcDate1.getUTCMonth() + 1).padStart(2, "0");
  const day3 = String(utcDate1.getUTCDate()).padStart(2, "0");
  const hours3 = String(utcDate1.getUTCHours()).padStart(2, "0");
  const minutes3 = String(utcDate1.getUTCMinutes()).padStart(2, "0");
  const seconds3 = String(utcDate1.getUTCSeconds()).padStart(2, "0");
  const utcTimestamp2 = `${year3}${month3}${day3}T${hours3}${minutes3}${seconds3}Z`;

  return [utcTimestamp1, utcTimestamp2];
};
export const convert12HourFormat = (time: any) => {
  const [hour, minute] = time.split(":").map(Number);

  const period = hour >= 12 ? "PM" : "AM";
  let formattedMinute: any = minute === 0 ? "00" : minute;
  const formattedHour = hour % 12 || 12;

  const formattedTime = `${formattedHour}:${formattedMinute} ${period}`;

  return formattedTime;
};
export const updateData = (
  row: any,
  expert: any,
  type: any,
  leadStatus: string,
  templateName: string
) => {
  return {
    message_history: row.data.message_history
      ? [
          { type: type, date: getCurrentTime(), template: templateName },
          ...row.data.message_history,
        ]
      : [{ type: type, date: getCurrentTime(), template: templateName }],
    date: row.data.date || "",
    time: row.data.time || "",
    date_time: row.data.date_time || "",
    expert: expert,
    service_booking_date: row.data.service_booking_date || "",
    lead_expert: row.data.lead_expert || "",
    service_booking_time: row.data.service_booking_time || "",
    comments: row.data.comments || [],
    call_picked: row.data.call_picked || "",
    lead_owner: row.data.lead_owner || "",
    lead_origin: row.data.lead_origin || "",
    lead_status: leadStatus,
    new_lead_status: leadStatus,
    lead_discovery_expert_mapping_datetime: "",
    lead_discovery_expert_mapping_template: "",
    lead_expert_mapping_datetime: row.data.lead_expert_mapping_datetime || "",
    lead_expert_mapping_template: row.data.lead_expert_mapping_template || "",
    name: row.data.client_information.name || "",
    email: row.data.client_information.email || "",
    phone: row.data.client_information.phone || "",
    age: row.data.client_information.age || "",
    gender: row.data.client_information.gender || "",
    country: row.data.client_information.country || "",
    state: row.data.client_information.state || "",
    city: row.data.client_information.city || "",
    nationality: row.data.client_information.nationality || "",
    languages: row.data.client_information.languages_known || [],
    educational_qualification:
      row.data.client_information.educational_qualification || "",
    relationship_status: row.data.client_information.relationship_status || "",
    dependents: row.data.client_information.dependents || "",
    student: row.data.client_information.student || "",
    occupation: row.data.client_information.occupation || "",
    occupation_type: row.data.client_information.occupation_type || "",
    family_mental_history:
      row.data.client_information.family_mental_history || "",
    issues: row.data.screening_information.issues || [],
    symptoms: row.data.screening_information.symptoms || "",
    frequency_of_symptoms:
      row.data.screening_information.frequency_of_symptoms || "",
    medication_history: row.data.screening_information.medication_history || "",
    therapeutic_histroy: row.data.screening_information.therapeutic_histroy,
    types_of_theraputic_history:
      row.data.screening_information.types_of_theraputic_history || "",
    urgency_of_intervention:
      row.data.screening_information.urgency_of_intervention || "",
    gender_of_therapist: row.data.expert_preferences.gender_of_therapist || "",
    age_group_of_therapist:
      row.data.expert_preferences.age_group_of_therapist || "",
    therapy_delivery_modes:
      row.data.treatment_preferences.therapy_delivery_modes || [],
    therapy_type: row.data.treatment_preferences.therapy_type || [],
    preferred_language: row.data.treatment_preferences.preferred_language || "",
    expert_suggested: row.data.screening_result.expert_suggested || "",
    suggested_expert_name:
      row.data.screening_result.suggested_expert_name || "",
    suggested_expert_name1:
      row.data.screening_result.suggested_expert_name1 || "",
    suggested_expert_name2:
      row.data.screening_result.suggested_expert_name2 || "",
    suggested_expert_name3:
      row.data.screening_result.suggested_expert_name3 || "",
    suggest_therapy_type: row.data.screening_result.suggest_therapy_type || "",
    reason_for_interest: row.data.screening_result.reason_for_interest || "",
    length_of_concern: row.data.screening_result.length_of_concern || "",
    current_physical_fitness:
      row.data.screening_result.current_physical_fitness || "",
    exercise_routine: row.data.screening_result.exercise_routine || "",
    health_problems: row.data.screening_result.health_problems || "",
    physical_pain: row.data.screening_result.physical_pain || "",
    physical_pain_description:
      row.data.screening_result.physical_pain_description || "",
    budget: row.data.screening_result.budget || "",
    notes: row.data.notes || "",
    ehc_followup_notes: row.data.ehc_followup_notes || "",
    payment_link_history: row.data.payment_link_history || [],
    marked_as: row.data.marked_as,
  };
};

export const updatePaymentLinkHistory = (
  data: any,
  link_obj: any,
  message_history: any
) => {
  return {
    date: data.date,
    service_booking_date: data.service_booking_date,
    lead_expert: data.lead_expert,
    service_booking_time: data.service_booking_time,
    comments: data.comments,
    time: data.time,
    date_time: data.date_time,
    expert: data.expert,
    session_history: data.session_history || [],
    name: data.client_information.name,
    email: data.client_information.email,
    phone: data.client_information.phone,
    call_picked: data.call_picked,
    age: data.client_information.age,
    gender: data.client_information.gender,
    country: data.client_information.country,
    state: data.client_information.state,
    city: data.client_information.city,
    nationality: data.client_information.nationality,
    languages: data.client_information.languages_known,
    educational_qualification:
      data.client_information.educational_qualification,
    relationship_status: data.client_information.relationship_status,
    dependents: data.client_information.dependents,
    student: data.client_information.student,
    occupation: data.client_information.occupation,
    occupation_type: data.client_information.occupation_type,
    family_mental_history: data.client_information.family_mental_history,
    symptoms: data.screening_information.symptoms,
    frequency_of_symptoms: data.screening_information.frequency_of_symptoms,
    issues: data.screening_information.issues,
    medication_history: data.screening_information.medication_history,
    therapeutic_histroy: data.screening_information.therapeutic_histroy,
    types_of_theraputic_history:
      data.screening_information.types_of_theraputic_history,
    urgency_of_intervention: data.screening_information.urgency_of_intervention,
    gender_of_therapist: data.expert_preferences.gender_of_therapist,
    age_group_of_therapist: data.expert_preferences.age_group_of_therapist,
    therapy_delivery_modes: data.treatment_preferences.therapy_delivery_modes,
    therapy_type: data.treatment_preferences.therapy_type,
    preferred_language: data.treatment_preferences.preferred_language,
    expert_suggested: data.screening_result.expert_suggested,
    suggested_expert_name1: data.screening_result.suggested_expert_name1,
    suggested_expert_name2: data.screening_result.suggested_expert_name2,
    suggested_expert_name3: data.screening_result.suggested_expert_name3,
    suggest_therapy_type: data.screening_result.suggest_therapy_type,
    notes: data.notes,
    ehc_followup_notes: data.ehc_followup_notes,
    reason_for_interest: data.screening_result.reason_for_interest,
    length_of_concern: data.screening_result.length_of_concern,
    current_physical_fitness: data.screening_result.current_physical_fitness,
    exercise_routine: data.screening_result.exercise_routine,
    health_problems: data.screening_result.health_problems,
    physical_pain: data.screening_result.physical_pain,
    physical_pain_description: data.screening_result.physical_pain_description,
    budget: data.screening_result.budget,
    lead_owner: data.lead_owner,
    lead_origin: data.lead_origin,
    lead_status: data.lead_status,
    new_lead_status: data.new_lead_status,
    lead_discovery_expert_mapping_datetime:
      data.lead_discovery_expert_mapping_datetime,
    booking_entry: data.booking_entry,
    lead_discovery_expert_mapping_template:
      data.lead_discovery_expert_mapping_template,
    lead_expert_mapping_datetime: data.lead_expert_mapping_datetime,
    lead_expert_mapping_template: data.lead_expert_mapping_template,
    message_history: data.message_history
      ? [...data.message_history, message_history]
      : [message_history],
    payment_link_history: data.payment_link_history
      ? [...data.payment_link_history, link_obj]
      : [link_obj],
    marked_as: data.marked_as,
  };
};

export const convertUtcToIST = (utcTimestamp: any) => {
  let monthNames: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const utcDate = new Date(utcTimestamp);
  const istDate = new Date(
    utcDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const istDateString = istDate.toLocaleDateString().replace(/\//g, "-");
  const date = istDateString.split("-");
  if (Number(date[0]) < 10) {
    date[0] = `0${date[0]}`;
  }
  const finalDate = `${date[1]}-${monthNames[Number(date[0]) - 1]}-${date[2]}`;

  const hours = istDate.getHours();
  const amPm = hours >= 12 ? "PM" : "AM";
  const finalHours = hours % 12 === 0 ? 12 : hours % 12;
  const finalMinutes = istDate.getMinutes().toString().padStart(2, "0");

  const finalTime = `${finalHours}:${finalMinutes} ${amPm}`;

  return [finalDate, finalTime];
};

export const getDateFormat = (dateString: string) => {
  let date = new Date(dateString);
  let day = date.getDate();
  let monthIndex = date.getMonth();
  let year = date.getFullYear();
  let monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let monthName = monthNames[monthIndex];
  let newDateString = day + "-" + monthName + "-" + year;
  return newDateString;
};
export const inprogressData = (obj: any) => {
  let sum = 0;
  if (obj.UPCOMING_DISCOVERY) {
    sum += Number(obj.UPCOMING_DISCOVERY.count);
  }
  if (obj.DISCOVERY_FOLLOWUP) {
    sum += Number(obj.DISCOVERY_FOLLOWUP.count);
  }
  if (obj.FOLLOWUP_HOLD) {
    sum += Number(obj.FOLLOWUP_HOLD.count);
  }
  if (obj.URGENT) {
    sum += Number(obj.URGENT.count);
  }
  if (obj.WORKSHOP) {
    sum += Number(obj.WORKSHOP.count);
  }
  if (obj.EXPERT_BOOKING) {
    sum += Number(obj.EXPERT_BOOKING.count);
  }
  if (obj.AESS_UPCOMING_REQUEST) {
    sum += Number(obj.AESS_UPCOMING_REQUEST.count);
  }
  if (obj.AESS_EXPERT_MAPPING) {
    sum += Number(obj.AESS_EXPERT_MAPPING.count);
  }
  if (obj.CORPORATE_LEADS) {
    sum += Number(obj.CORPORATE_LEADS.count);
  }
  if (obj.EMAIL_MARKEING) {
    sum += Number(obj.EMAIL_MARKEING.count);
  }
  if (obj.DAY1_FIRST) {
    sum += Number(obj.DAY1_FIRST.count);
  }
  if (obj.DAY1_SECOND) {
    sum += Number(obj.DAY1_SECOND.count);
  }
  if (obj.DAY2) {
    sum += Number(obj.DAY2.count);
  }
  if (obj.DAY3) {
    sum += Number(obj.DAY3.count);
  }
  return sum;
};

export const formatXAxisTick = (name: string) => {
  const parts = name.split(" to ");
  if (parts.length !== 2) {
    return name;
  }
  const [startDate, endDate] = parts;
  const formattedStartDate = new Date(startDate);
  const formattedEndDate = new Date(endDate);
  const startMonth = formattedStartDate.toLocaleString("default", {
    month: "short",
  });
  const endMonth = formattedEndDate.toLocaleString("default", {
    month: "short",
  });
  const formattedStartDay = formattedStartDate.getDate();
  const formattedEndDay = formattedEndDate.getDate();
  return `${formattedStartDay} ${startMonth} to\n${formattedEndDay} ${endMonth}`;
};
export const inprogressLeads = (obj: any) => {
  let arr: any = [];
  if (obj.UPCOMING_DISCOVERY) {
    arr = [...arr, ...obj.UPCOMING_DISCOVERY.leads];
  }
  if (obj.DISCOVERY_FOLLOWUP) {
    arr = [...arr, ...obj.DISCOVERY_FOLLOWUP.leads];
  }
  if (obj.FOLLOWUP_HOLD) {
    arr = [...arr, ...obj.FOLLOWUP_HOLD.leads];
  }
  if (obj.URGENT) {
    arr = [...arr, ...obj.URGENT.leads];
  }
  if (obj.WORKSHOP) {
    arr = [...arr, ...obj.WORKSHOP.leads];
  }
  if (obj.EXPERT_BOOKING) {
    arr = [...arr, ...obj.EXPERT_BOOKING.leads];
  }
  if (obj.AESS_UPCOMING_REQUEST) {
    arr = [...arr, ...obj.AESS_UPCOMING_REQUEST.leads];
  }
  if (obj.AESS_EXPERT_MAPPING) {
    arr = [...arr, ...obj.AESS_EXPERT_MAPPING.leads];
  }
  if (obj.CORPORATE_LEADS) {
    arr = [...arr, ...obj.CORPORATE_LEADS.leads];
  }
  if (obj.EMAIL_MARKEING) {
    arr = [...arr, ...obj.EMAIL_MARKEING.leads];
  }
  if (obj.DAY1_FIRST) {
    arr = [...arr, ...obj.DAY1_FIRST.leads];
  }
  if (obj.DAY1_SECOND) {
    arr = [...arr, ...obj.DAY1_SECOND.leads];
  }
  if (obj.DAY2) {
    arr = [...arr, ...obj.DAY2.leads];
  }
  if (obj.DAY3) {
    arr = [...arr, ...obj.DAY3.leads];
  }
  return arr;
};
export function convertToArray(inputArray: any) {
  let outputArray = [];

  for (let item of inputArray) {
    if (typeof item === "string") {
      outputArray.push({
        value: item,
        label: item.charAt(0).toUpperCase() + item.slice(1),
      });
    } else if (
      typeof item === "object" &&
      item.hasOwnProperty("value") &&
      item.hasOwnProperty("label")
    ) {
      outputArray.push(item);
    }
  }

  return outputArray;
}
